import { endOfDay, format } from 'date-fns';

const DATE_TIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ssXXX";

export const getDiscoveryDateRange = (currentDate = new Date()) => ({
  startDate: format(new Date(2020, 0, 1, 0, 0, 0), DATE_TIME_FORMAT),
  endDate: format(endOfDay(currentDate), DATE_TIME_FORMAT)
});
